var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBeritaUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.6667C8.29417 15.1225 5.71667 14.85 3.70333 15.8492C3.14917 16.1233 2.5 15.7492 2.5 15.1308V5.70333C2.5 5.19749 2.72917 4.71249 3.13 4.40416C5.20417 2.80666 8.1275 2.99666 10 4.97416C11.8725 2.99666 14.7958 2.80666 16.87 4.40499C17.2708 4.71333 17.5 5.19833 17.5 5.70333V15.13C17.5 15.7483 16.8508 16.1233 16.2967 15.8483C14.2833 14.85 11.7058 15.1225 10 16.6667V16.6667Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 16.6667V4.97499",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeritaUnselected);
export default __webpack_public_path__ + "static/media/icon_berita_unselected.d2f4eb383ee6d0feb4ca961b744afdbf.svg";
export { ForwardRef as ReactComponent };